import { cmsModule } from '@utils';

export default [...cmsModule('heading'), cmsModule('intro'), cmsModule('product-features'), cmsModule('trajectory'), cmsModule('recognition')];
